import { RadioGroup, RadioGroupItem, Tab } from '@features/ui';
import { useCallback, useMemo, useState } from 'react';
import {
  categoryRadioData,
  platformRadioData,
} from '@features/admin/packages/packagesData.ts';
import { TTab } from '@src/types';
import { ExchangePackageTable } from '@features/admin/packages';
import { useNavigate } from 'react-router-dom';

export const PackagesPage = () => {
  const [platformRadioSelected, setPlatformRadioSelected] = useState<string>();
  const [categoryRadioSelected, setCategoryRadioSelected] = useState<string>();
  const [tabActive, setTabActive] = useState(0);

  const navigate = useNavigate();

  const handleEdit = useCallback(
    (id: string) => {
      navigate(`/admin/packages/${id}`);
    },
    [navigate]
  );

  const tabs = useMemo(
    (): TTab[] => [
      {
        label: 'Exchange Packages',
        component: <ExchangePackageTable onEdit={handleEdit} />,
      },
    ],
    [handleEdit]
  );

  return (
    <div>
      <div className={'flex justify-between items-center'}>
        <h1 className={'text-[23px]'}>Leeloo Packages</h1>
        <div className={'flex items-center gap-x-3 text-xs'}>
          <p className={'text-lg'}>Platform</p>
          <RadioGroup
            className={'flex item-center gap-x-2'}
            defaultValue={platformRadioSelected}
            onValueChange={(value) => setPlatformRadioSelected(value)}
          >
            {platformRadioData.map((item) => {
              return (
                <div key={item.value} className={'flex items-center gap-x-2'}>
                  <RadioGroupItem value={item.value} />
                  <p>{item.label}</p>
                </div>
              );
            })}
          </RadioGroup>
        </div>
      </div>
      <div className={'mt-4.5 relative'}>
        <div
          className={'flex items-center gap-x-3 text-xs absolute right-0 z-1'}
        >
          <p className={'text-lg'}>Category</p>
          <RadioGroup
            className={'flex item-center gap-x-2'}
            defaultValue={categoryRadioSelected}
            onValueChange={(value) => setCategoryRadioSelected(value)}
          >
            {categoryRadioData.map((item) => {
              return (
                <div key={item.value} className={'flex items-center gap-x-2'}>
                  <RadioGroupItem value={item.value} />
                  <p>{item.label}</p>
                </div>
              );
            })}
          </RadioGroup>
        </div>
        <Tab
          className={'pb-2 mb-7.5'}
          tabActive={tabActive}
          tabs={tabs}
          onChangeTab={setTabActive}
        />
      </div>
    </div>
  );
};
